<template>
    <v-app id="inspire">
        <v-card class="mx-auto" max-width="100%">
            <v-container>
                <v-row dense>
                    <v-col cols="12">
                        <v-card color="#385F73" dark>
                            <v-card-title class="headline">
                                Misión:
                            </v-card-title>

                            <v-card-text>
                                <p>
                                    * Preservar la vida, la salud y el medio ambiente en situaciones de emergencia.
                                </p>
                                <p>
                                    * Idem para la brigada contra incendios, preservando además los bienes materiales en
                                    situaciones de emergencia e incendios.
                                </p>
                                <p>
                                    * Realizar permanentemente acciones de prevención, actuando como auditores
                                    naturales, observando actitudes, factores y condiciones relacionadas con el respeto
                                    a normativas de higiene y seguridad, de salud ocupacional, y de medio ambiente, a
                                    fin de evitar accidentes y situaciones de emergencia.
                                </p>
                                <p>
                                    * Prepararse mediante capacitación y entrenamiento para afrontar situaciones de
                                    emergencia, en caso de producirse.
                                </p>

                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-app>
</template>

<script>
// import router from "../src/router/index";
// import axios from "../src/axios-auth.js";
import moment from "moment";

export default {
    data: () => ({
        usuario: null,
        now: moment(),
        diferencia: "",
    }),
    watch: {},
    created() {
        this.usuario = this.$store.state.usuario.toString().trim();
    },
    mounted() {
        if (this.$store.state.usuario == "" || this.$store.state.usuario == null) {
            this.$store.dispatch("logout");
        } else {
            this.$store.state.sector = "Brigadas";
            //  this.cargaraccidentes();
        }
    },
    methods: {},
};
</script>